module.exports = __webpack_public_path__ + "static/media/retail (1).62fde5bc.svg";